<div
  style="font-size: 12px; color: white; background: #171717; padding: 15px 0px"
>
  <div
    style="display: -webkit-flex; flex-direction: column; align-items: center"
  >
    <h1>MY TICKETS</h1>
    <div
      *ngIf="
        spotlightsTickets.length === 0 &&
        showcaseTickets.length === 0 &&
        screeningPartiesTickets.length === 0 &&
        subscriptions.length === 0 && 
        !isLoading
      "
    >
      <p>No Tickets Available..</p>
    </div>
    <div
      class="tickets_container"
      *ngIf="
        (spotlightsTickets.length !== 0 ||
          showcaseTickets.length !== 0 ||
          screeningPartiesTickets.length !== 0||
          subscriptions.length !== 0 
          ) &&
        !isLoading
      "
    >
      <h2
        *ngIf="
          spotlightsTickets.length > 0 || screeningPartiesTickets.length > 0
        "
      >
        Live Events or All-Access Pass
      </h2>

<!-- Subscription ticket Start -->
      <div
      *ngIf="subscriptions.length > 0"
      style="
        flex-shrink: 0;
        display: -webkit-flex;
        flex-wrap: wrap;
        width: 100%;
        justify-content: space-around;
      "
    >
      <div
        *ngFor="let ticket of subscriptions; let i = index"
        style="
          display: -webkit-flex;
          flex-direction: column;
          padding: 15px;
          width: 325px;
          margin-bottom: 15px;
        "
      >
      <div class="spotlight_subscription_container">            
        <div (click)="selectTicket('subscription', ticket)"style="background-color: #de1b36;padding: 15px 0px 15px 15px;color:white">
            <div class="bd-border_dotted_subscription"></div>
            <div class="order-number-container" style="color: black;">
              <div class="order-number">{{ ticket.OrderID }}</div>
            </div>
            <div class="bd-border_solid" style="background-color: #de1b36;"></div>
            <div style="font-weight: bold">{{ticket.purchaseTransactionType==='SUBSCRIPTION_ALL'?'All Access  Pass':ticket.purchaseTransactionType==='SUBSCRIPTION_SPOTLIGHT'?'Spotlight Access Pass':'Showcase Access Pass'}}</div>
            <div style="font-size: 10px; margin-top: 5px; display: flex;gap: 2px;">
              Venue -
              <p>{{ticket.purchaseTransactionType==='SUBSCRIPTION_ALL'?'Cinejoy':ticket.purchaseTransactionType==='SUBSCRIPTION_SPOTLIGHT'?'Spotlight':'Showcase'}}</p>
            </div>
            <div style="font-size: 10px">
              <ng-container *ngIf="ticket.purchaseSource === 'STRIPE'" >
                <div style="font-size: 10px; margin-top: 5px; display: flex;gap: 2px;">
                  <p>Expiry Date :</p>
                  
                  <p>{{ticket.expiryTime | date :"medium" }}</p>

                </div>
              </ng-container>
            </div>
            <ng-container *ngIf="ticket.purchaseSource === 'STRIPE'">
              <div style="font-size: 10px; margin-top: 5px; display: flex;gap: 2px;">
                <p>{{ticket.purchaseTransactionType==='SUBSCRIPTION_SPOTLIGHT'?'Spotlight Access Pass Amount : ': ticket.purchaseTransactionType ==='SUBSCRIPTION_SHOWCASE'?'Showcase Access Pass Amount : ':'All Access Pass Amount : '}}</p>
                <p>
                  {{
                    ticket.ticketAmount / 100
                      | currency : "USD" : undefined : "1.2-2"
                  }}
                </p>
              </div>
            </ng-container>
          </div>
        </div>
        <div style="align-self: center">
          <a href="/cinejoy/how-to">{{ticket.purchaseTransactionType==='SUBSCRIPTION_SPOTLIGHT'?'Spotlight Access Pass': ticket.purchaseTransactionType ==='SUBSCRIPTION_SHOWCASE'?'Showcase Access Pass':'All Access Pass'}}</a>
        </div>
      </div>
      </div>
<!-- Subscription ticket end -->
      <div
        *ngIf="spotlightsTickets.length > 0"
        style="
          flex-shrink: 0;
          display: -webkit-flex;
          flex-wrap: wrap;
          width: 100%;
          justify-content: space-around;
        "
      >
        <div
          *ngFor="let ticket of spotlightsTickets; let i = index"
          style="
            display: -webkit-flex;
            flex-direction: column;
            padding: 15px;
            width: 325px;
            margin-bottom: 15px;
          "
        >
          <div class="ticket_container">
            <div (click)="selectTicket('spotlights', ticket)">
              <div class="bd-border_dotted"></div>
              <div class="order-number-container">
                <div class="order-number">{{ ticket.OrderID }}</div>
              </div>
              <div class="bd-border_solid"></div>
              <div style="font-weight: bold">{{ ticket.Name }}</div>
              <div style="font-size: 10px; margin-top: 5px">
                <p>Spotlight</p>
              </div>
              <div style="font-size: 10px; margin-top: 5px;display: flex;gap: 2px;">
                Venue -
                <p>{{ ticket.VenueName }}</p>
              </div>
              <div style="font-size: 10px">
                <p>
                  {{
                    pacificTimezone(ticket.StartDateTime) | date: 'medium'
                  }}
                  {{ userTimezoneName(ticket.StartDateTime) }}
                </p>
              </div>
              <ng-container *ngIf="ticket.purchaseSource === 'STRIPE'">
                <div style="font-size: 10px; margin-top: 5px;display: flex;gap: 2px;">
                  <p>Ticket Amount :</p>
                  <p>
                    {{
                      ticket.ticketAmount / 100
                        | currency : "USD" : undefined : "1.2-2"
                    }}
                  </p>
                </div>
                <div
                  style="font-size: 10px; margin-top: 5px"
                  *ngIf="
                    ticket.guestUsernames.length ||
                    ticket.remainingHostTicketCount
                  "
                >
                  Your Group -
                  <p class="mb-0">
                    {{
                      ticket.userType === "HOST"
                        ? "You (Host)"
                        : ticket.hostUser.firstName + " (Host)"
                    }}
                  </p>
                  <details
                    (click)="$event.stopPropagation()"
                    data-toggle="tooltip"
                    title="Click here to see all the guests in your Group"
                  >
                    <summary (click)="$event.stopPropagation()">Guests</summary>
                    <ul>
                      <li *ngFor="let user of ticket.guestUsers">
                        {{ user.firstName }}
                        <span
                          *ngIf="(userData.emailAddress === user.emailAddress)"
                          class="ms-1"
                          >(You)</span
                        >
                      </li>
                    </ul>
                  </details>
                </div>
              </ng-container>
            </div>
            <div
              *ngIf="
                ticket.guestUsernames.length || ticket.remainingHostTicketCount
              "
            >
              <button
                mat-flat-button
                *ngIf="
                  ticket.purchaseSource === 'STRIPE' &&
                  ticket.userType == 'HOST'
                "
                (click)="openAssignRemoveTicketDialog(ticket)"
                color="primary"
                style="
                  background: #140305;
                  width: 7.2rem;
                  height: 2.2rem;
                  margin-top: 5px;
                  text-align: center;
                  font-size: 0.8rem;
                "
              >
                Manage Ticket
              </button>
            </div>
          </div>
          <div style="align-self: center">
            <a href="/cinejoy/premiere/upcoming">Spotlights</a>
          </div>
        </div>
      </div>
      <div *ngIf="showcaseTickets.length > 0" class="showcase-heading">
        <h2>Showcase Movies</h2>
        <h5>
          All Showcase Movies can be watched during the Cinejoy Festival,
          occurring March 24, 2025- March 31, 2025. You have 48 hours to complete
          your screening.
        </h5>
      </div>
      <div
        style="
          flex-shrink: 0;
          display: -webkit-flex;
          flex-wrap: wrap;
          width: 100%;
          justify-content: space-around;
        "
      >
        <div
          *ngFor="let ticket of showcaseTickets; let i = index"
          style="
            display: -webkit-flex;
            flex-direction: column;
            padding: 15px;
            width: 325px;
            margin-bottom: 15px;
          "
        >
          <div
            class="ticket_container"
            (click)="selectTicket('showcase', ticket)"
            style="background-color: #d7be69; color: black; font-weight: bold"
          >
            <div class="bd-border_dotted"></div>
            <div class="order-number-container">
              <div class="order-number">{{ ticket.OrderID }}</div>
            </div>
            <div class="bd-border_solid"></div>
            <div>{{ ticket.Name }}</div>
            <div style="font-size: 10px; margin-top: 5px">
              <p>Showcase Movie</p>
            </div>
            <div style="font-size: 10px; margin-top: 5px;display: flex;gap: 2px;" >
              Venue -
              <p>{{ ticket.VenueName }}</p>
            </div>
            <div style="font-size: 10px">
              <p>
                  {{
                   pacificTimezone(ticket.StartDateTime) | date: 'medium'
                  }}
                {{ userTimezoneName(ticket.StartDateTime) }}
              </p>
            </div>
            <div style="font-size: 10px; margin-top: 5px;display: flex;gap: 2px;">
              <p>Ticket Amount :</p>
              <p>
                {{
                  ticket.ticketAmount / 100
                    | currency : "USD" : undefined : "1.2-2"
                }}
              </p>
            </div>
          </div>
          <div style="align-self: center">
            <a href="/cinejoy/showcase">Showcase</a>
          </div>
        </div>
      </div>
      <!-- screening parties ticket -->
      <div *ngIf="screeningPartiesTickets.length > 0" class="showcase-heading">
        <h2>Artist & Audience Meetup</h2>
      </div>
      <div
        *ngIf="screeningPartiesTickets.length > 0"
        style="
          flex-shrink: 0;
          display: -webkit-flex;
          flex-wrap: wrap;
          width: 100%;
          justify-content: space-around;
        "
      >
        <div
          *ngFor="let ticket of screeningPartiesTickets; let i = index"
          style="
            display: -webkit-flex;
            flex-direction: column;
            padding: 15px;
            width: 325px;
            margin-bottom: 15px;
          "
        >
          <div
            class="ticket_container"
            (click)="selectTicket('screeningParties', ticket)"
            style="background-color: #d7be69; color: black; font-weight: bold"
          >
            <div class="bd-border_dotted"></div>
            <div class="order-number-container">
              <div class="order-number">
                {{ ticket.cinejoyFeaturedMovieList[0][0].id }}
              </div>
            </div>
            <div class="bd-border_solid"></div>
            <div>{{ ticket.cinejoyFeaturedMovieList[0][0].name }}</div>
            <div>{{ ticket.firstName }} {{ ticket.lastName }}</div>
            <div style="font-size: 10px; margin-top: 5px">
              <p>Screening Party</p>
            </div>
            <div style="font-size: 10px; margin-top: 5px">
              {{ ticket.ScreeningPartyDate | date : "MMM dd, yyyy h:mm:ss a" }}
              {{ userTimezoneNameSP(ticket.ScreeningPartyDate) }}
            </div>
            <div style="font-size: 10px; margin-top: 5px; display: flex;gap: 2px;">
              Venue -
              <p>{{ ticket.meetingType }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
  </div>
  <div class="modal-footer custom-modal-footer">
    <button
      style="
        background: #de1b36 !important;
        float: right;
        border: 1px red solid;
      "
      class="btn btn-warning modalOkButton"
      type="button"
      (click)="closeModal()"
    >
      Close
    </button>
  </div>
</div>
